/* eslint-disable */ /* eslint-disable arrow-parens */
import { Grid, Box, SpeedDial, Tabs, Tab, IconButton, SpeedDialAction, Tooltip } from "@mui/material";
import { Suspense, useEffect, useRef } from "react";
import Fab from "@mui/material/Fab";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { useContext } from "react";
import { useCallback, useMemo, useState } from "react";
import Draggable from "react-draggable";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import { useLocation, useHistory } from "react-router-dom";
import {
	DependentsContext,
	EnrollmentContext,
	AuthContext,
	ThemeContext,
	EligibleDependentContext,
	PaycheckContext,
	GroupOwnerContext
} from "../../../contexts";
import "./enrollment.css";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import Slide from "@mui/material/Slide";
import TableContainer from "@mui/material/TableContainer";

import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import DownloadIcon from "@mui/icons-material/Download";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import DifferenceIcon from "@mui/icons-material/Difference";

import { Member } from "../../../types/member.types";
import React from "react";

import { api } from "../../../utils/api";
import {
	EnrollmentSchema,
	PlanNavigationMap,
	Status,
	VEBEnrollmentSchema,
	VEBEnrollmentStatus
} from "../../../types/enrollment.types";
import VEBPlanAcknowledgement from "./plans/VEBPlanAknowledgement/VEBPlanAcknowledgement";
import EnrollmentTabLabel from "./enrollmentTabLabel/EnrollmentTabLabel";
import { downloadBrochureFile } from "../../../utils/commonFunctions/downloadFile";

import { trackPromise } from "react-promise-tracker";
import { dollarize } from "../../../utils/commonFunctions/dollarize";
import EligiblityDialog from "./eligiblityDialogs/EligiblityDialog";
import axios from "axios";
import { port, url } from "../../../config/config";

import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Chip } from "@material-ui/core";
import initCapitalize from "../../../utils/commonFunctions/initCapitalize";
import EmailIcon from "@mui/icons-material/Email";
import CustomModal from "../../shared/customModal/CustomModal";
import StackForm from "./StackForm";
import { ALL_PLANS } from "../../../constants/allPlan";
import { getActiveVEBPlans } from "../../../utils/api/pages/VEBPlaniInit";
import { BrandingPageA1 } from "./BrandingPageA1";
import CommonForm from "./CommonForm";
import KemperWholeLifeInsuaranceForm from "./plans/kemper/wholeLife/form/WholeLifeInsuranceForm";
import FiveStarFamilyProtectionForm from "./plans/fiveStar/familyProtection/form/FamilyProtectionForm";
import { useVEBEnrollmentData } from "../../../hooks/useVEBEnrollment";
import TermLifeForm from "./plans/Manhattan/TermLifeForm";
import { EnrollmentModal } from "../../shared/EventsModal/EnrollmentModalVEB";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.action.hover
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14
	}
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:nth-of-type(even)": {
		backgroundColor: theme.palette.action.hover
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0
	}
}));

function a11yProps(index: number) {
	return {
		id: `vertical-tab-${index}`,
		"aria-controls": `vertical-tabpanel-${index}`
	};
}

const Enrollment = (): JSX.Element => {
	// console.log("[Enrollment] Component rendering - checking if remounting");
	const [activeTab, setActiveTab] = useState<string>();
	const [loading, setLoading] = useState(false);
	const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
	const { currentEnrollment, setCurrentEnrollment, deleteCurrentEnrollment } = useContext(EnrollmentContext);
	const { paycheck } = useContext(PaycheckContext);
	const [visitedPlans, setVisitedPlans] = useState<string[]>([]);
	const [value, setValue] = useState<string>();
	const [VEBEnrollmentStatus, setVEBEnrollmentStatus] = useState<VEBEnrollmentStatus | null>(null);
	const [VEBOpenEnrollment, setVEBOpenEnrollment] = useState<any[]>([]);
	const [VEBEnrollments, setVEBEnrollments] = useState<VEBEnrollmentSchema[]>([]);
	const [overallPremiums, setOverallPremiums] = useState<any[]>([]);
	const [dependents, setDependents] = useState<Member[]>([]);
	const [VEBPlans, setVEBPlans] = useState<any[]>([]);
	const [buttonCaption, setButtonCaption] = useState<PlanNavigationMap>({});
	const [totalPremium, setTotalPremium] = useState<number>(0.0);
	const location = useLocation();
	const { theme } = useContext(ThemeContext);
	const { member } = useContext(AuthContext);
	const { eligiblity } = useContext(EligibleDependentContext);
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const height = screen.height;
	const [showOverallPremium, setShowOverallPremium] = useState(true);
	const [togglePlan, setTogglePlan] = useState(false);
	const [width, setWidth] = useState<number>(window.innerWidth);
	const history = useHistory();
	const { groupOwner } = useContext(GroupOwnerContext);
	const VEBPlansRef = useRef(VEBPlans);

	const [previousEnrollments, setPreviousEnrollments] = useState<VEBEnrollmentSchema[]>([]);

	// hook
	const {
		data: vebData,
		loading: vebLoading,
		refresh,
		isEnrollmentModalOpen,
		enrollmentModalPlans,
		closeEnrollmentModal
	} = useVEBEnrollmentData();

	const [stackPlanName, setStackPlanName] = useState<string>("");
	const [VEBBenefits, setVEBBenefits] = useState<any>();
	const [openStackFormModal, setOpenStackFormModal] = useState<boolean>(false);
	const vebDataRef = useRef(vebData);

	const overallPremiumChipColor = {
		ACTIVE: {
			background_color: "#d5e5d9",
			text_color: "#4cb464"
		},
		CURRENT: {
			background_color: "#f0ebc5",
			text_color: "#c9b30c"
		},
		WAIVED: {
			background_color: "#f7e9e9",
			text_color: "#eb2a2a"
		}
	};

	const speedDialActions = [
		// eslint-disable-next-line prettier/prettier
		{
			name: <div className="tooltip-speed-dial">Download&nbsp;Brochure</div>,
			icon: <DownloadIcon />,
			actionName: "download_brochure"
		},
		{
			name: <div className="tooltip-speed-dial">Email&nbsp;Brochure</div>,
			icon: <AttachEmailIcon />,
			actionName: "email_brochure"
		}
	];
	const [scheduleAppointmentDialogProps, setScheduleAppointmentDialogProps] = useState({
		openDialog: false,
		title: "Schedule an appointment with Enroller",
		actions: [
			{
				label: "Cancel",
				callback: () => {
					setScheduleAppointmentDialogProps(
						Object.assign({}, scheduleAppointmentDialogProps, { openDialog: false })
					);
				}
			},
			{
				label: "Confirm",
				callback: () => {
					setScheduleAppointmentDialogProps(
						Object.assign({}, scheduleAppointmentDialogProps, { openDialog: true })
					);
				}
			}
		]
	});
	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<any>();
	// const [scheduleAppointmentDateTime, setScheduleAppointmentDateTime] = useState(null);
	const [speedDialOpen, setSpeedDialOpen] = useState(true);

	const handleOpen = () => setSpeedDialOpen(true);

	const handleClose = () => setSpeedDialOpen(false);

	const handleToggle = () => {
		setTogglePlan(!togglePlan);
	};
	const handleEligibilityDialogOpen = useCallback(() => {
		const step = urlSearchParams.get("step");
		if (!activeTab) return;

		setEligiblityDialogProps({
			openDialog: true,
			handleCloseEligiblityDialog: () =>
				setEligiblityDialogProps((prev: any) => ({
					...prev,
					openDialog: false
				})),
			eligibleDependents: eligiblity.eligibleDependents,
			ineligibleRelationshipDependents: eligiblity.ineligibleRelationshipDependents,
			ineligibleDependents: eligiblity.ineligibleDependents,
			VEBPlanName: step
		});
	}, [eligiblity, eligiblityDialogProps, urlSearchParams]);

	const handleChange = useCallback(
		(event: React.SyntheticEvent<Element, Event>, newValue: string) => {
			setActiveTab(newValue);
			setValue(newValue);
			deleteCurrentEnrollment();

			// FIXED - compare plan_name to newValue, map to strings
			VEBPlans.forEach((element, index) => {
				if (element.plan_name === newValue) {
					// ← compare plan_name
					const selectedRange = VEBPlans.slice(0, index + 1).map((p) => p.plan_name); // ← extract strings
					setVisitedPlans([...selectedRange]);
				}
			});
		},
		[deleteCurrentEnrollment, VEBPlans] // ← also add VEBPlans as dependency
	);

	// just commit to make it visible to my commit NP-1332

	//avi comminting
	// const getOpenEnrollments = useCallback(async () => {
	// 	try {
	// 		if (!member) {
	// 			// alert(" Member is null or undefined");
	// 			return;
	// 		}

	// 		const groupNumber = member.group_number;
	// 		if (!groupNumber) {
	// 			// alert("The group number is null");
	// 			return;
	// 		} else {
	// 			localStorage.setItem("group_number", `${groupNumber}`);
	// 		}
	// 		setLoading(true);
	// 		// this is the rtk api call
	// 		const { currentPlans, futurePlans } = await getActiveVEBPlans(Number(groupNumber));

	// 		// const allPlans = [...currentPlans, ...futurePlans];
	// 		const formattedPlans = currentPlans.map((plan) => ({
	// 			...plan,
	// 			status: plan.status ?? null
	// 		}));

	// 		setVEBPlans(formattedPlans);
	// 		setLoading(false);
	// 		// console.log(currentPlans, futurePlans);
	// 	} catch (err) {
	// 		setLoading(false);
	// 		console.error("Failed to fetch open enrollments", err);
	// 	}
	// }, [member]);
	const getOpenEnrollments = useCallback(async () => {
		const groupNumber = member?.group_number;
		if (!groupNumber) return;
		localStorage.setItem("group_number", `${groupNumber}`);
		setLoading(true);
		try {
			const { currentPlans } = await getActiveVEBPlans(Number(groupNumber));
			setVEBPlans(currentPlans.map((plan) => ({ ...plan, status: plan.status ?? null })));
		} catch (err) {
			console.error("Failed to fetch open enrollments", err);
		} finally {
			setLoading(false);
		}
	}, [member?.group_number]);
	const initialVisitedPlans = useCallback(() => {
		if (!VEBPlans || VEBPlans.length === 0) {
			return;
		}
		setVisitedPlans([VEBPlans[0].plan_name]); // ← dynamic first plan
	}, [VEBPlans]); // ← also add VEBPlans as dependency

	const handleOverallPremiumClick = () => {
		setShowOverallPremium((prevShowOverallPremium: boolean) => !prevShowOverallPremium);
	};

	const getOverallPremium = useCallback(() => {
		// console.log("VEBEnrollments", VEBEnrollments);
		const _overallPremiums: any[] = [];
		let activeVEBEnrollments: any[] = [];
		let waivedVEBEnrollments: any[] = [];
		const _overallPremiumsPayload: any[] = [];
		const _activeVEBEnrollmentsPlanName: any[] = [];
		activeVEBEnrollments = VEBEnrollments.filter((eachEnrollment: any) => {
			return eachEnrollment.enrollment_status === "ACTIVE";
		});

		// console.log("Active VEB Enrollments", activeVEBEnrollments);
		waivedVEBEnrollments = VEBEnrollments.filter((eachEnrollment: any) => {
			return eachEnrollment.enrollment_status === "WAIVED";
		});
		// console.log("Waived VEB Enrollments", waivedVEBEnrollments);
		// waivedVEBEnrollments.forEach((waivedEnrollment: any) => {
		// if (waivedVEBEnrollments.includes(waivedEnrollment.base_plan_name) === true) {
		// waivedVEBEnrollments.pop(wai)
		// }
		// })
		activeVEBEnrollments.forEach((activeVEBEnrollment: any) => {
			_activeVEBEnrollmentsPlanName.push(activeVEBEnrollment.base_plan_name);
			_overallPremiumsPayload.push(activeVEBEnrollment);
		});
		const pushedWaivedPlanNames: string[] = [];
		waivedVEBEnrollments.forEach((waivedVEBEnrollment: any) => {
			const { base_plan_name } = waivedVEBEnrollment;
			if (
				_activeVEBEnrollmentsPlanName.includes(base_plan_name) === false &&
				pushedWaivedPlanNames.includes(base_plan_name) === false
			) {
				_overallPremiumsPayload.push(waivedVEBEnrollment);
				pushedWaivedPlanNames.push(base_plan_name);
			}
		});
		// console.log("Plan Name", _activeVEBEnrollmentsPlanName);
		_overallPremiumsPayload.sort((prevEnroll, currentEnroll) => {
			return new Date(prevEnroll.createdAt).getTime() - new Date(currentEnroll.createdAt).getTime();
		});
		let _totalPremium = 0;
		const seenBasePlans = new Set<string>();

		_overallPremiumsPayload.forEach((VEBEnrollment: EnrollmentSchema) => {
			const { base_plan_name, premium_amount, enrollment_status, total_premium } = VEBEnrollment;

			if (base_plan_name !== currentEnrollment?.plan_name && !seenBasePlans.has(base_plan_name)) {
				seenBasePlans.add(base_plan_name);

				_overallPremiums.push({
					plan_name: base_plan_name,
					premium_amount: total_premium,
					status: enrollment_status
				});

				_totalPremium += total_premium;
			}
		});

		// console.log("_totalPremium", _totalPremium);
		setTotalPremium(_totalPremium);
		setOverallPremiums(Object.assign([], _overallPremiums));
	}, [VEBEnrollments, currentEnrollment]);

	function handleWindowSizeChange() {
		setWidth(window.innerWidth);
	}

	const getVEBEnrollmentStatus = useCallback(
		(planName: string, VEBEnrollments: VEBEnrollmentSchema[], VEBOpenEnrollment): Status => {
			let enrollment: Status = "CLOSED";

			for (let enrollmentIdx = 0; enrollmentIdx < VEBEnrollments.length; enrollmentIdx++) {
				if (VEBEnrollments[enrollmentIdx]?.base_plan_name === planName) {
					enrollment = VEBEnrollments[enrollmentIdx].enrollment_status;
					break;
				}
			}

			return enrollment;
		},
		[]
	);

	// const getVEBEnrollmentInitData = useCallback(async () => {
	// try {
	// setLoading(true);

	// const { VEBOpenEnrollment, dependents, VEBEnrollments } = await trackPromise(
	// api.pages.getVEBEnrollmentInitData()
	// );

	// setDependents([...dependents]);
	// setVEBEnrollments([...VEBEnrollments]);
	// setVEBOpenEnrollment(
	// Array.isArray(VEBOpenEnrollment) ? VEBOpenEnrollment : VEBOpenEnrollment ? [VEBOpenEnrollment] : []
	// );

	// const groupNumber = Number(localStorage.getItem("group_number"));

	// const { currentPlans, futurePlans } = await getActiveVEBPlans(groupNumber);
	// // const allPlans = [...currentPlans, ...futurePlans];

	// const formattedPlans = currentPlans.map((plan) => ({
	// ...plan,
	// status: plan.status ?? null
	// }));

	// setVEBPlans(formattedPlans);

	// const _VEBEnrollmentStatus: VEBEnrollmentStatus = {};
	// formattedPlans.forEach((plan: any) => {
	// const planName = plan.plan_name ?? plan.open_enrollment?.veb_plan_name ?? "UNKNOWN_PLAN";
	// const status = getVEBEnrollmentStatus(planName, VEBEnrollments, VEBOpenEnrollment);

	// _VEBEnrollmentStatus[planName] = { enrollment: status };
	// });

	// setVEBEnrollmentStatus(Object.keys(_VEBEnrollmentStatus).length > 0 ? _VEBEnrollmentStatus : null);
	// } catch (err) {
	// console.error(err);
	// } finally {
	// setLoading(false);
	// }
	// }, [getVEBEnrollmentStatus]);
	// Process VEB data from hook when it arrives
	const getVEBEnrollmentInitData = useCallback(async () => {
		// console.log("[Enrollment] Refreshing VEB data via hook");
		await refresh(); // This will trigger the hook to re-fetch and update vebData
	}, [refresh]);

	//avi adding
	const computeOverallPremium = useCallback(
		(freshEnrollments: any[]) => {
			if (freshEnrollments.length === 0) return;
			const active = freshEnrollments.filter((e: any) => e.enrollment_status === "ACTIVE");
			const waived = freshEnrollments.filter((e: any) => e.enrollment_status === "WAIVED");
			const payload = [...active];
			const activeNames = active.map((e: any) => e.base_plan_name);
			const pushedWaived: string[] = [];
			waived.forEach((w: any) => {
				if (!activeNames.includes(w.base_plan_name) && !pushedWaived.includes(w.base_plan_name)) {
					payload.push(w);
					pushedWaived.push(w.base_plan_name);
				}
			});
			payload.sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
			let total = 0;
			const seen = new Set<string>();
			const premiums: any[] = [];
			const currentPlanName = currentEnrollment?.plan_name;
			payload.forEach((e: any) => {
				if (e.base_plan_name !== currentPlanName && !seen.has(e.base_plan_name)) {
					seen.add(e.base_plan_name);
					premiums.push({
						plan_name: e.base_plan_name,
						premium_amount: e.total_premium,
						status: e.enrollment_status
					});
					total += e.total_premium;
				}
			});
			setTotalPremium(total);
			setOverallPremiums([...premiums]);
		},
		[currentEnrollment?.plan_name]
	);
	// Process VEB data when it changes
	useEffect(() => {
		if (!vebData) return;

		// console.log("[Enrollment] Processing VEB data from hook");

		const { VEBOpenEnrollment: vebOpenData, dependents: depsData, VEBEnrollments: vebEnrollData, previousEnrollments: prevEnrollData } = vebData;
		const plans = VEBPlansRef.current;

		setDependents(depsData);
		setVEBEnrollments(vebEnrollData);
		setVEBOpenEnrollment(Array.isArray(vebOpenData) ? vebOpenData : vebOpenData ? [vebOpenData] : []);
		computeOverallPremium(vebEnrollData); // ✅ always fresh

		setPreviousEnrollments(prevEnrollData ?? []);

		if (plans.length > 0) {
			const status: VEBEnrollmentStatus = {};
			plans.forEach((plan: any) => {
				const name = plan.plan_name ?? plan.open_enrollment?.veb_plan_name ?? "UNKNOWN_PLAN";
				status[name] = { enrollment: getVEBEnrollmentStatus(name, vebEnrollData, vebOpenData) };
			});
			setVEBEnrollmentStatus(Object.keys(status).length > 0 ? status : null);
		}
	}, [vebData, computeOverallPremium]);
	useEffect(() => {
		if (VEBPlans.length === 0 || !vebDataRef.current) return;
		const { VEBOpenEnrollment: vebOpenData, VEBEnrollments: vebEnrollData } = vebDataRef.current;
		const status: VEBEnrollmentStatus = {};
		VEBPlans.forEach((plan: any) => {
			const name = plan.plan_name ?? plan.open_enrollment?.veb_plan_name ?? "UNKNOWN_PLAN";
			status[name] = { enrollment: getVEBEnrollmentStatus(name, vebEnrollData, vebOpenData) };
		});
		setVEBEnrollmentStatus(Object.keys(status).length > 0 ? status : null);
	}, [VEBPlans, getVEBEnrollmentStatus]);
	// useEffect(() => {
	// 	if (!vebData) return;

	// 	console.log("[Enrollment] Processing VEB data from hook");

	// 	const { VEBOpenEnrollment: vebOpenData, dependents: depsData, VEBEnrollments: vebEnrollData } = vebData;

	// 	setDependents(depsData);
	// 	setVEBEnrollments(vebEnrollData);
	// 	setVEBOpenEnrollment(Array.isArray(vebOpenData) ? vebOpenData : vebOpenData ? [vebOpenData] : []);

	// 	if (VEBPlans.length > 0) {
	// 		const _VEBEnrollmentStatus: VEBEnrollmentStatus = {};
	// 		VEBPlans.forEach((plan: any) => {
	// 			const planName = plan.plan_name ?? plan.open_enrollment?.veb_plan_name ?? "UNKNOWN_PLAN";
	// 			const status = getVEBEnrollmentStatus(planName, vebEnrollData, vebOpenData);
	// 			_VEBEnrollmentStatus[planName] = { enrollment: status };
	// 		});
	// 		setVEBEnrollmentStatus(Object.keys(_VEBEnrollmentStatus).length > 0 ? _VEBEnrollmentStatus : null);
	// 	}
	// }, [vebData, VEBPlans.length, getVEBEnrollmentStatus]);

	useEffect(() => {
		// Only show loading if we don't have plans yet (initial load)
		if (VEBPlans.length === 0) {
			setLoading(vebLoading);
		}
	}, [vebLoading, VEBPlans.length]);

	const setButtonCaptionForForwardAndBackwardMovement = useCallback(() => {
		const _buttonCaption: any = {};

		VEBPlans.forEach((plan, index) => {
			_buttonCaption[plan.plan_name] = {
				nextPlan: index < VEBPlans.length - 1 ? VEBPlans[index + 1].plan_name : "",
				prevPlan: index > 0 ? VEBPlans[index - 1].plan_name : ""
			};
		});

		setButtonCaption(_buttonCaption);
	}, [VEBPlans]);
	const handleEmailBrochurePost = useCallback(
		async (download = false) => {
			const step = urlSearchParams.get("step");
			if (!step || !member) {
				return;
			}
			let _fileName;
			let _planName = step;
			switch (step) {
				case "Cancer":
					// _fileName = "Cancer_Kemper_Brochure_file.pdf";
					_planName = "Cancer";
					break;
				case "Whole life":
					// _fileName = "Whol_ Life_Kemper_Brochure_ Guide_file.pdf";
					_planName = "Whole life";
					break;
				case "Critical Illness":
					// _fileName = "Critica_ Illness_Kemper_Brochure_file.pdf";
					_planName = "Critical Illness";
					break;
				case "Short Term Disability":
					// _fileName = "Short_Term_Disability_Kemper_Brochure_file.pdf";
					_planName = "Short Term Disability";
					break;
				case "Accident":
					// _fileName = "Accident_Kemper_Brochure_file.pdf";
					_planName = "Accident";
					break;
				case "Hospital Indemnity":
					// _fileName = "HI_Plans1_2_3_4 with rates 092222 (2).pdf";
					_planName = "Hospital Indemnity";
					break;
				case "Group Life Indemnity":
					// _fileName = "Custom_EE_GLI-Brookshire_Bros_file.pdf";
					_planName = "Group Life Indemnity";
					break;
				case "Family Protection":
					// _fileName = "Term_Life_to_ Age_121_5Star_Brochure_Guide_file.pdf";
					_planName = "Family Protection";
					break;
				case "Doc and Rx":
					// _fileName = "Call_Up_A_Doc_file.pdf";
					_planName = "Doc and Rx";
					break;
				case "Vision":
					// _fileName = "Beam_file.pdf";
					_planName = "Vision";
					break;
				case "Dental":
					_planName = "Dental";
					break;
			}

			const { group_number, email, first_name, last_name, employee_SSN } = member;

			const planCodeForMailingBrochure: any =
				VEBOpenEnrollment?.filter(
					(enrollment: any) => enrollment.open_enrollment.veb_plan_name == activeTab
				).map((enrollment: any) => enrollment.open_enrollment.veb_plan_code) || [];
			const payload: any = {
				email: email,
				// filename: _fileName,
				group_number: group_number,

				type: ALL_PLANS.type.veb,
				employee_class: paycheck?.employee_class,
				employee_SSN: employee_SSN,
				plan_name: _planName,
				// plan_code: _planName,
				subject: `Dear Employee: ${first_name} ${last_name} , Your plan brochure `
			};

			if (planCodeForMailingBrochure.length > 0) {
				payload.plan_code = planCodeForMailingBrochure[0];
			}

			if (download == true) {
				payload.download = true;
			}
			const response = await trackPromise(api.email.emailBrochureV2(payload));
			// console.log("Email brochure", response);
			if (response?.status === 200) {
				if (download != true) {
					alert("Email brochure has been successfully sent");
				} else {
					downloadBrochureFile(response.data.file.content, response.data.file.filename);
				}
			}
			// if (response) {
			// alert("Email brochure has been successfully sent");
			// }
		},
		[VEBOpenEnrollment, member, paycheck?.employee_class, urlSearchParams]
	);

	const handleDownloadBrochureClick = useCallback(() => {
		//we have to implement the logic for this
		handleEmailBrochurePost(true);
	}, [handleEmailBrochurePost]);

	// const handleScheduleAppointmentDialogClose = useCallback(() => {
	// setScheduleAppointmentDialogProps(Object.assign({}, scheduleAppointmentDialogProps, { openDialog: false }));
	// }, [scheduleAppointmentDialogProps]);

	const handleScheduleAppointmentDialogOpenClick = useCallback(() => {
		setScheduleAppointmentDialogProps((prevScheduleAppointmentDialogProps: any) =>
			Object.assign({}, prevScheduleAppointmentDialogProps, { openDialog: true })
		);
	}, []);

	const handleGetCurrentEnrollmentBenefitDetailsMail = useCallback(async () => {
		const { group_number, SSN } = member;
		const currentEnrollmentQuery = {
			group_number,
			SSN
		};
		try {
			const response = await api.enrollment.getEnrollmentCurrentBenefitEmail(currentEnrollmentQuery);
			if (response) alert("Successfully the mail has been sent!");
		} catch (error) {
			alert("Eror:404Something went wrong!");
		}
	}, [member]);
	// const handleChangePlanButtonClick = useCallback(
	// (direction: "FORWARD" | "BACKWARD") => {
	// console.log("VEBEnrollments", VEBEnrollments);
	// if (!VEBPlans || !VEBPlans.length || !activeTab) return null;

	// const currentIndex = VEBPlans.findIndex((p) => p.plan_name === activeTab);
	// if (currentIndex === -1) return null;

	// let newIndex = currentIndex;
	// if (direction === "FORWARD" && currentIndex < VEBPlans.length - 1) {
	// newIndex = currentIndex + 1;
	// } else if (direction === "BACKWARD" && currentIndex > 0) {
	// newIndex = currentIndex - 1;
	// }

	// const newPlan = VEBPlans[newIndex];
	// setActiveTab(newPlan.plan_name);
	// setVisitedPlans((prev) => [...new Set([...prev, newPlan.plan_name])]);

	// return direction; // <- explicitly return
	// },
	// [VEBPlans, activeTab]
	// );

	const handleChangePlanButtonClick = useCallback(
		(direction: "FORWARD" | "BACKWARD") => {
			if (!VEBPlans?.length || !activeTab) return null;

			const currentIndex = VEBPlans.findIndex((p) => p.plan_name === activeTab);
			if (currentIndex === -1) return null;

			// helper: check if plan already enrolled
			const isPlanEnrolled = (planCode: string) =>
				VEBEnrollments?.some((enrollment) => enrollment.plan_code === planCode);

			let newIndex = currentIndex;

			while (true) {
				if (direction === "FORWARD") {
					newIndex++;
					if (newIndex >= VEBPlans.length) return null; // reached end
				} else {
					newIndex--;
					if (newIndex < 0) return null; // reached start
				}

				const nextPlan = VEBPlans[newIndex];

				//  skip if already enrolled
				if (!isPlanEnrolled(nextPlan.plan_code)) {
					setActiveTab(nextPlan.plan_name);
					setVisitedPlans((prev) => [...new Set([...prev, nextPlan.plan_name])]);
					return direction;
				}
			}
		},
		[VEBPlans, activeTab, VEBEnrollments]
	);

	const renderPlan = useCallback(() => {
		if (VEBEnrollmentStatus === null) {
			return;
		}
		const planName = activeTab; // <-- use the active tab
		const stage = urlSearchParams.get("stage");

		if (!planName) return;

		// console.log(activeTab);
		const Plan = VEBPlans.find((p) => p.plan_name === activeTab);
		if (VEBEnrollmentStatus === null) return;

		// VEBPlans is your array from the API
		if (!VEBPlans || !VEBPlans.length) return;

		const allPlanNames: string[] = VEBPlans.map((plan) => plan.plan_name);

		if (!Plan) return null;
		const vebplanName = Plan?.plan_name;

		if (activeTab && Plan) {
			if (stage === "0") {
				if (
					VEBEnrollmentStatus &&
					["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
						(VEBEnrollmentStatus as Record<string, any>)[vebplanName]?.enrollment
					) &&
					VEBEnrollments
				) {
					return (
						// console.log("consolelog 1", VEBOpenEnrollment, VEBEnrollments, activeTab),
						<VEBPlanAcknowledgement
							VEBOpenEnrollment={VEBOpenEnrollment}
							VEBEnrollments={VEBEnrollments}
							VEBPlanName={activeTab}
						/>
					);
				} else {
					return (
						<BrandingPageA1
							planName={Plan.plan_name}
							planCode={Plan.plan_code}
							groupNumber={Number(localStorage.getItem("group_number"))}
							VEBOpenEnrollment={VEBOpenEnrollment}
							getVEBEnrollmentInitData={getVEBEnrollmentInitData}
							// Pass Next/Previous logic here
							changePlanProps={{
								handleChangePlanButtonClick: handleChangePlanButtonClick,
								buttonCaption: buttonCaption[activeTab]
							}}
							currentIndex={VEBPlans.findIndex((p) => p.plan_name === activeTab)}
							totalPlans={VEBPlans.length}
						/>
					);
				}
			} else if (stage === "1") {
				if (!VEBOpenEnrollment) return null;
				return (
					<CommonForm
						dependents={dependents}
						VEBOpenEnrollment={VEBOpenEnrollment}
						getVEBEnrollmentInitData={getVEBEnrollmentInitData}
						planname={activeTab}
						stage={stage}
						planCode={Plan.plan_code}
						previousEnrollments={previousEnrollments}
					/>
				);
			} else if (stage === "2") {
				return (
					// console.log("consolelog 2", VEBOpenEnrollment, VEBEnrollments, activeTab),
					<VEBPlanAcknowledgement
						VEBOpenEnrollment={VEBOpenEnrollment}
						VEBEnrollments={VEBEnrollments}
						VEBPlanName={activeTab}
						getVEBEnrollmentInitData={getVEBEnrollmentInitData}
					/>
				);
			}
		}
	}, [
		VEBEnrollmentStatus,
		VEBEnrollments,
		VEBOpenEnrollment,
		dependents,
		getVEBEnrollmentInitData,
		urlSearchParams,
		activeTab, 
		previousEnrollments
	]);

	const handleOpenStackFormModalClick = () => {
		setOpenStackFormModal(true);
	};
	const handleCloseStackFormModalClick = () => {
		setOpenStackFormModal(false);
	};

	const handleStackEnrollmentClick = useCallback(async () => {
		const step = urlSearchParams.get("step");

		setStackPlanName(step ? step : "");

		const getBenefitsQuery: any = {
			base_plan_name: step,
			// group_number: member.group_number,
			insured_SSN: member.SSN
			// member_SSN: member.SSN
		};
		const benefitsResponse: any = (
			await trackPromise(api.enrollment.getActiveVEBEnrollmentWithRider(getBenefitsQuery))
		).vebEnrollmentsForStack;

		setVEBBenefits(benefitsResponse);

		handleOpenStackFormModalClick();
	}, [member, urlSearchParams]);

	// useEffect(() => {
	// getVEBEnrollmentInitData();
	// initialVisitedPlans();
	// }, [getVEBEnrollmentInitData, initialVisitedPlans]);

	useEffect(() => {
		initialVisitedPlans();
	}, [initialVisitedPlans]);
	//avi comminting
	// useEffect(() => {
	// 	if (!member) return;
	// 	getOpenEnrollments();
	// 	// getOverallPremium();
	// }, [getOpenEnrollments, getOverallPremium]);
	useEffect(() => {
		if (!member) return;
		getOpenEnrollments();
	}, [getOpenEnrollments]);

	//avi adding
	useEffect(() => {
		VEBPlansRef.current = VEBPlans;
	}, [VEBPlans]);
	useEffect(() => {
		vebDataRef.current = vebData;
	}, [vebData]);
	useEffect(() => {
		getOverallPremium();
	}, [getOverallPremium]);

	useEffect(() => {
		if (activeTab) {
			history.push("?step=" + activeTab + "&stage=0");
			// console.log("step", activeTab);
		}
	}, [activeTab, history]);

	useEffect(() => {
		// console.log("VEBEnrollmentss", VEBEnrollments);
		if (currentEnrollment) {
			const _overallPremiums: any[] = [];
			let _totalPremium = 0;
			VEBEnrollments.forEach((VEBEnrollment: EnrollmentSchema) => {
				const { base_plan_name, premium_amount, enrollment_status } = VEBEnrollment;
				if (base_plan_name !== currentEnrollment?.plan_name) {
					_overallPremiums.push({
						plan_name: base_plan_name,
						premium_amount: premium_amount,
						status: enrollment_status
					});
					_totalPremium += premium_amount;
				}
			});
			setTotalPremium(() => Number((_totalPremium + currentEnrollment.premium_amount).toFixed(2)));
		}
	}, [VEBEnrollments, currentEnrollment]);
	useEffect(() => {
		const handleResize = () => handleWindowSizeChange();

		window.addEventListener("resize", handleResize);

		// pick the first plan automatically if no tab is active
		if (!activeTab && VEBPlans.length > 0) {
			setActiveTab(VEBPlans[0].plan_name);
		}

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [VEBPlans, activeTab, handleWindowSizeChange]);

	useEffect(() => {
		const timer = setTimeout(handleScheduleAppointmentDialogOpenClick, 1000);
		return () => clearTimeout(timer);
	}, [handleScheduleAppointmentDialogOpenClick]);
	useEffect(() => {
		// // console.log("i am running", urlSearchParams);
		if (VEBPlans.length > 0) {
			setButtonCaptionForForwardAndBackwardMovement();
		}
	}, [VEBPlans]);
	// console.log("VEBEnrollmentStatus", VEBEnrollmentStatus);

	useEffect(() => {
		// console.log("i am running", urlSearchParams);
		if (activeTab) {
			if (
				!urlSearchParams ||
				urlSearchParams == undefined ||
				urlSearchParams.get("step") == undefined ||
				!urlSearchParams.get("step")
			) {
				if (activeTab) {
					history.push("?step=" + activeTab + "&stage=0");
				} else {
					initialVisitedPlans();
				}
			}
		}
	}, [activeTab, history, initialVisitedPlans, urlSearchParams, visitedPlans]);
	// console.log("hi from the Enrollment");
	return (
		<>
			{eligiblityDialogProps ? (
				<Suspense fallback={<div />}>
					<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
				</Suspense>
			) : null}
			{activeTab ? (
				<>
					<Suspense fallback={<div />}>
						<CustomModal open={openStackFormModal} onClose={handleCloseStackFormModalClick} title="">
							<StackForm
								onClose={handleCloseStackFormModalClick}
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
								planName={stackPlanName}
								vebBenefits={VEBBenefits}
							/>
						</CustomModal>
					</Suspense>

					<div className="veb-enrollment">
						<Box
							className="box-container"
							sx={{
								flexGrow: 1,
								display: "flex",
								flexDirection: "row"
							}}
						>
							{/* ── Mobile: Show Plans trigger ── */}
							<div
								className={
									!togglePlan && width <= 820
										? "open-plan-list show-list"
										: "open-plan-list hide-list"
								}
								onClick={handleToggle}
							>
								<KeyboardArrowRightIcon className="arrow-icon" style={{ color: theme.button.color }} />
								Show Plans
							</div>

							{width <= 820 ? (
								/* ── Mobile Sidebar (Slide) ── */
								<Slide direction="right" in={togglePlan} mountOnEnter unmountOnExit>
									<div className="show-plan">
										<div className="close-plan-list show-list" onClick={handleToggle}>
											Hide Plans
										</div>
										<Tabs
											orientation="vertical"
											className="tabs-cotainer"
											style={{
												boxShadow:
													"rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px",
												borderTopLeftRadius: 20,
												borderTopRightRadius: 20,
												borderBottomLeftRadius: 20,
												borderBottomRightRadius: 20,
												color: theme.primary_color
											}}
											TabIndicatorProps={{
												style: {
													color: theme.primary_color,
													backgroundColor: theme.primary_color
												}
											}}
											value={value}
											onChange={handleChange}
										>
											{VEBEnrollmentStatus &&
												VEBPlans.map((openEnrollment: any, index: number) => {
													const { plan_name, status, plan_code } = openEnrollment;
													return (
														<Tab
															key={openEnrollment._id}
															className={
																activeTab === plan_name
																	? visitedPlans.includes(plan_name)
																		? "VEB-active-tab VEB-TAB-tracker"
																		: "VEB-active-tab"
																	: visitedPlans.includes(plan_name)
																	? "VEB-active-tab VEB-TAB-tracker"
																	: "VEB-default-tab"
															}
															style={{
																height: (height - 500) / 6,
																color:
																	activeTab === plan_name
																		? theme.primary_color
																		: undefined
															}}
															value={plan_name}
															onClick={handleToggle}
															label={
																VEBEnrollmentStatus?.[plan_name]?.enrollment ? (
																	<EnrollmentTabLabel
																		planName={plan_name}
																		status={
																			VEBEnrollmentStatus?.[plan_name]
																				?.enrollment ?? "N/A"
																		}
																		isOpenEnrollment={
																			VEBOpenEnrollment &&
																			VEBOpenEnrollment.length > 0
																				? true
																				: false
																		}
																		carrier={
																			openEnrollment.carrier_name ?? "Unknown"
																		}
																	/>
																) : (
																	<></>
																)
															}
															{...a11yProps(0)}
														/>
													);
												})}
										</Tabs>
									</div>
								</Slide>
							) : (
								/* ── Desktop: Floating Sidebar + Toggle Button ── */
								<>
									{/* Sidebar wrapper */}
									<div className="floating-sidebar-wrapper">
										<div className={`floating-sidebar ${sidebarCollapsed ? "collapsed" : ""}`}>
											{/* Header */}
											<div className="sidebar-header">
												<span className="sidebar-header-title">Benefit Plans</span>
												<span className="sidebar-plan-count">{VEBPlans.length} plans</span>
											</div>

											{/* Scrollable tabs */}
											<div className="tabs-scroll-area">
												<Tabs
													orientation="vertical"
													className="tabs-container"
													style={{
														color: theme.primary_color
													}}
													TabIndicatorProps={{
														style: {
															color: theme.primary_color,
															backgroundColor: theme.primary_color
														}
													}}
													value={value}
													onChange={handleChange}
												>
													{VEBEnrollmentStatus &&
														VEBPlans.map((openEnrollment: any) => {
															const { plan_name } = openEnrollment;
															return (
																<Tab
																	key={openEnrollment._id}
																	className={
																		activeTab === plan_name
																			? visitedPlans.includes(plan_name)
																				? "VEB-active-tab VEB-TAB-tracker"
																				: "VEB-active-tab"
																			: visitedPlans.includes(plan_name)
																			? "VEB-active-tab VEB-TAB-tracker"
																			: "VEB-default-tab"
																	}
																	style={{
																		color:
																			activeTab === plan_name
																				? theme.primary_color
																				: undefined
																	}}
																	value={plan_name}
																	label={
																		VEBEnrollmentStatus?.[plan_name]?.enrollment ? (
																			<EnrollmentTabLabel
																				planName={plan_name}
																				status={
																					VEBEnrollmentStatus?.[plan_name]
																						?.enrollment ?? "N/A"
																				}
																				isOpenEnrollment={
																					VEBOpenEnrollment?.length > 0
																				}
																				carrier=""
																			/>
																		) : (
																			<></>
																		)
																	}
																	{...a11yProps(0)}
																/>
															);
														})}
												</Tabs>
											</div>

											{/* Footer */}
											<div className="sidebar-footer">
												<span className="sidebar-footer-dot" />
												{visitedPlans.length} of {VEBPlans.length} reviewed
											</div>
										</div>

										<div
											className={`floating-toggle-btn ${sidebarCollapsed ? "collapsed" : ""}`}
											onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
										>
											<KeyboardArrowRightIcon />
										</div>
									</div>

									{/* Main content — fills remaining width and full height */}
									<div
										className={`form-container ${
											sidebarCollapsed ? "sidebar-collapsed" : "sidebar-expanded"
										}`}
									>
										{renderPlan()}
									</div>
								</>
							)}
						</Box>

						{/* Overall Premium Draggable Box */}
						{showOverallPremium ? (
							<Draggable>
								<div className="draggable-premium-box">
									<div>
										<div
											className={"top-bar-expand"}
											style={{ backgroundColor: theme.button.background_color }}
										>
											<div className="header" style={{ color: theme.button.color }}>
												Overall Premium (Current OE)
											</div>
											<div className={"icon-expand"}>
												<IconButton onClick={handleOverallPremiumClick}>
													<KeyboardArrowRightIcon style={{ color: theme.button.color }} />
												</IconButton>
											</div>
										</div>
									</div>
									<div>
										<div
											style={{
												backgroundColor: "#e3e1e1",
												padding: "1rem",
												display: "flex",
												fontWeight: "bold",
												alignItems: "center",
												gap: "20%"
											}}
										>
											<div className="header" style={{ color: "#242424", flex: "1" }}>
												<span>VEB&nbsp;Plan(s)</span>
											</div>
											<div
												className="header"
												style={{ fontSize: "1rem", marginLeft: "2rem", flex: "3" }}
											>
												Premium&nbsp;($)
											</div>
											<div
												className="header"
												style={{ color: "#242424", marginRight: "12rem", flex: "1" }}
											>
												Status
											</div>
										</div>
									</div>
									<TableContainer
										component={Paper}
										style={{ zIndex: 99999, maxHeight: "300px", overflowY: "auto" }}
									>
										<Table sx={{ minWidth: 300 }} aria-label="customized table">
											<TableBody>
												{overallPremiums.map((overallPremium: any, index: number) => (
													<StyledTableRow key={index}>
														<StyledTableCell component="th" scope="row">
															{overallPremium.plan_name}
														</StyledTableCell>
														<StyledTableCell align="right">
															{overallPremium.premium_amount.toFixed(2)}
														</StyledTableCell>
														{overallPremium.status ? (
															<StyledTableCell align="right">
																<Chip
																	label={initCapitalize(overallPremium.status)}
																	style={{
																		backgroundColor: `${
																			overallPremium.status === "ACTIVE"
																				? overallPremiumChipColor.ACTIVE
																						.background_color
																				: overallPremium.status === "WAIVED"
																				? overallPremiumChipColor.WAIVED
																						.background_color
																				: null
																		}`,
																		color: `${
																			overallPremium.status === "ACTIVE"
																				? overallPremiumChipColor.ACTIVE
																						.text_color
																				: overallPremium.status === "WAIVED"
																				? overallPremiumChipColor.WAIVED
																						.text_color
																				: null
																		}`,
																		fontWeight: "700"
																	}}
																/>
															</StyledTableCell>
														) : null}
													</StyledTableRow>
												))}
												{currentEnrollment ? (
													<StyledTableRow>
														<StyledTableCell component="th" scope="row">
															{currentEnrollment.plan_name}
														</StyledTableCell>
														<StyledTableCell align="right">
															{currentEnrollment.premium_amount}
														</StyledTableCell>
														<StyledTableCell align="right">
															<Chip
																label={initCapitalize(currentEnrollment.status)}
																style={{
																	backgroundColor:
																		overallPremiumChipColor.CURRENT
																			.background_color,
																	color: overallPremiumChipColor.CURRENT.text_color,
																	fontWeight: "700"
																}}
															/>
														</StyledTableCell>
													</StyledTableRow>
												) : null}
											</TableBody>
										</Table>
									</TableContainer>
									<div>
										<div
											style={{
												backgroundColor: "#e3e1e1",
												padding: "0.3rem",
												display: "flex",
												fontWeight: "bold",
												alignItems: "center",
												gap: "20%"
											}}
										>
											<div className="header" style={{ color: "#242424", marginLeft: "1rem" }}>
												TOTAL AMOUNT
											</div>
											<div className="show-premium" style={{ fontSize: "1.3rem" }}>
												{dollarize(Number(totalPremium.toFixed(2))) +
													(currentEnrollment ? "*" : "")}
											</div>
										</div>
									</div>
								</div>
							</Draggable>
						) : (
							<Draggable axis="y">
								<div className="draggable-premium-box">
									<div>
										<div
											className={"top-bar"}
											style={{ backgroundColor: theme.button.background_color }}
										>
											<div className="header" style={{ color: theme.button.color }}>
												Overall Amount
											</div>
											<div className={"icon"}>
												<IconButton onClick={handleOverallPremiumClick}>
													<KeyboardArrowRightIcon style={{ color: theme.button.color }} />
												</IconButton>
											</div>
										</div>
									</div>
								</div>
							</Draggable>
						)}
					</div>

					{/* FABs */}
					<Tooltip title="Get Current Benefit Details">
						<Fab
							sx={{
								position: "fixed",
								bottom: 18,
								right: 156,
								bgcolor: theme.primary_color,
								"&:hover": { bgcolor: theme.primary_color }
							}}
							onClick={handleGetCurrentEnrollmentBenefitDetailsMail}
						>
							<EmailIcon style={{ color: "white" }} />
						</Fab>
					</Tooltip>
					<Fab
						onClick={handleScheduleAppointmentDialogOpenClick}
						sx={{ position: "fixed", bottom: 18, right: 86 }}
					>
						<DateRangeIcon />
					</Fab>
					<SpeedDial
						ariaLabel="SpeedDial tooltip example"
						sx={{ position: "fixed", bottom: 16, right: 16 }}
						icon={<SpeedDialIcon />}
						onOpen={handleOpen}
						onClose={handleClose}
						open={speedDialOpen}
						style={{ fontSize: "10px" }}
						FabProps={{ sx: { bgcolor: theme.primary_color, "&:hover": { bgcolor: theme.primary_color } } }}
					>
						{speedDialActions.map((speedDialAction: any) => (
							<SpeedDialAction
								key={speedDialAction.name}
								icon={speedDialAction.icon}
								tooltipTitle={<div className="tooltip-speed-dial">{speedDialAction.name}</div>}
								tooltipOpen
								onClick={
									speedDialAction.actionName === "email_brochure"
										? handleEmailBrochurePost
										: handleDownloadBrochureClick
								}
								style={{ fontSize: "10px" }}
							/>
						))}
						{urlSearchParams.get("stage") === "1" && (
							<SpeedDialAction
								icon={<DifferenceIcon />}
								tooltipTitle={<div className="tooltip-speed-dial">Check&nbsp;Eligibility</div>}
								tooltipOpen
								onClick={handleEligibilityDialogOpen}
								style={{ fontSize: "10px" }}
							/>
						)}
						<SpeedDialAction
							icon={<AttachFileIcon />}
							tooltipTitle={<div className="tooltip-speed-dial">Generate&nbsp;Eligibility</div>}
							tooltipOpen
							onClick={async () => {
								try {
									const res = await trackPromise(
										axios.get(`${url}:${port}/api/v1/carrier-transmission/kemper`)
									);
									if (res) alert("Succesfully generated! Check your email");
								} catch (err) {
									alert(err);
								}
							}}
							style={{ fontSize: "10px" }}
						/>
					</SpeedDial>
				</>
			) : (
				<>
					<div
						style={{
							padding: "16px",
							border: "1px solid #e0e0e0",
							borderRadius: "8px",
							backgroundColor: "#fafafa",
							textAlign: "center",
							color: "#555",
							fontSize: "14px",
							lineHeight: 1.5
						}}
					>
						{loading || vebLoading ? (
							<div style={{ color: "#888" }}>Loading...</div>
						) : (
							<div>
								<div style={{ fontWeight: 600, marginBottom: "6px" }}>No Plan Available</div>
								<div>
									There are currently no plans available for the selected option. Please check back
									later or try selecting a different plan or category.
								</div>
							</div>
						)}
					</div>
				</>
			)}
			<EnrollmentModal
				isOpen={isEnrollmentModalOpen}
				onClose={closeEnrollmentModal}
				planNames={enrollmentModalPlans}
			/>
		</>
	);
};

export default Enrollment;
